import React from "react"
import { connect } from "react-redux"
import TwoFactorSetupModal from "../../shared-components/adminSharedComp/OtpModal/TwoFactorSetupModal"

class TwoFactorSetupPage extends React.Component {
  handleSuccess = () => {
    if (this.props.onTwoFactorEnabled) {
      this.props.onTwoFactorEnabled()
    }
  }

  render() {
    return (
      <TwoFactorSetupModal
        open={true}
        onOpenChange={() => {}}
        accountInfo={this.props.accountInfo}
        required={true}
        onSuccess={this.handleSuccess}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  accountInfo: state.auth.accountInfo,
})

export default connect(mapStateToProps)(TwoFactorSetupPage)